/** Spinner shown inside the page frame while a route's code is fetched; the sidebar and top bar stay put. */
export function RouteFallback() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center" role="status" aria-live="polite">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-muted dark:text-dark-muted">Indlæser...</p>
      </div>
    </div>
  );
}
